import { Icon, Text } from "@smartsuite/react-ui/lib";
import type React from "react";

import { texts } from "./SomethingWentWrong.text";

export const SomethingWentWrong: React.FC = () => {
  return (
    <section className="something-went-wrong">
      <div className="something-went-wrong__content">
        <Icon className="something-went-wrong__icon" name="database-off-thin" size="MISC" />
        <Text className="something-went-wrong__title" size="xl" weight="semibold">
          {texts.title}
        </Text>
        <Text className="something-went-wrong__description" size="l">
          {texts.description}
        </Text>
      </div>
    </section>
  );
};
